import { Expo, TweenMax } from 'gsap';
// import 'gsap/ScrollToPlugin';

/**
 * Opens an element
 *
 * @example
 * import {open} from '../helpers';
 *
 * open($('.element'));
 *
 * @param {Object} el - HTML element you want to target for animation
 * @param {Number} speed - Speed of the animation
 * @param {String} ease - Ease of the animation
 * @param {Function} onComplete - On complete function
 */
export const open = (el, speed = 0.4, ease = 'easeOut', onComplete) => {
  TweenMax.set(el, { height: 'auto' });
  TweenMax.from(el, speed, { height: 0, ease: Expo[ease], onComplete });
};

/**
 * Closes an element
 *
 * @example
 * import {close} from '../helpers';
 *
 * close($('.element'));
 *
 * @param {Object} el - HTML element you want to target for animation
 * @param {Number} speed - Speed of the animation
 * @param {String} ease - Ease of the animation
 * @param {Function} onComplete - On complete function
 */
export const close = (el, speed = 0.4, ease = 'easeOut', onComplete) => {
  TweenMax.to(el, speed, { height: 0, ease: Expo[ease], onComplete });
};

// /**
// * Scrolls to a certain part of the page with GSAP
// *
// * @param {Number} y - The new y position
// * @param {Number} speed - The spped in which the screen scrolls
// * @param {Function} onComplete - On complete function
// */
// export const scrollTo = (y, speed = 1.5, onComplete) => {
//   TweenMax.to(window, speed, { scrollTo: { y }, ease: Expo.easeOut, onComplete });
// };

/**
 * Renders React modules on a page
 *
 * @example
 * import {renderReactModule} from '../helpers';
 *
 * {name: 'bar/SomeComponent',
 *   render(component, el) {
 *     renderReactModule(component, el);
 *   }
 * }
 *
 * @param {Object} component - HTML element you want to target for animation
 * @param {Object} el - HTML element you want to target for animation
 * @param {Object} data - Additional data to be passed in to the React component
 */
export const renderReactModule = (component, el, data) => {
  const length = el.length;
  const React = require('react');
  const ReactDom = require('react-dom');

  for (let i = 0; i < length; i++) {
    ReactDom.render(
      React.createElement(component, { ...data, ...el[i].dataset }),
      el[i]
    );
  }
};

export const paginate = (array, size, page) => {
  return array.slice((page - 1) * size, page * size);
};

export const getTotalPages = (total, size) => {
  return Math.ceil(total / size);
};

export const waitFor = (variable, callback) => {
  const interval = window.setInterval(() => {
    if (window[variable]) {
      window.clearInterval(interval);
      callback();
    }
  }, 200);
};

export const waitForElm = selector => {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new window.MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
};

export const stripHTML = html => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

export const convertToSlug = Text =>
  Text.toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');

export const isInViewport = elem => {
  const distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const initBorderAnimation = element => {
  const statsCircle = element.closest('.the-outcome-v2__stats-circle');
  statsCircle.querySelector('circle').classList.add('animate-circle');
};

export const getIsMobile = () =>
  window.matchMedia('(max-width: 1024px)').matches;
